import React from "react";
import "../styles/texstyle.css";

function CTA() {
  return <div className="CTA">Take the right step into a new tomorrow</div>;
}

export default CTA;
